var map = {
	"./labmem_text_btnnext_en.png": "e678",
	"./labmem_text_btnnext_jp.png": "082a",
	"./labmem_text_btnnext_kr.png": "0ac0",
	"./labmem_text_btnnext_sc.png": "f407",
	"./labmem_text_btnnext_tc.png": "638c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0628";